var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"messenger-info-page",attrs:{"id":"messenger-container"}},[_c('c-messanger-banner'),_c('c-info-content')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }